import { H2, ScrollView, XStack, YStack } from '@bounty/creators-design-system'
import { GetStoreResponseSuccess } from '@bounty/types'
import { VideoCard } from '../../../../components/VideoCard'

export const FeaturedVideos = ({
  featuredVideos,
}: {
  featuredVideos: GetStoreResponseSuccess['data']['featuredVideos']
}) => {
  return (
    <YStack width="100%" maxWidth={1300} alignSelf="center">
      <H2 mb="$4" px="$4" size="$xl" $gtMd={{ size: '$3xl' }}>
        Top Videos
      </H2>
      <ScrollView space="$4" horizontal>
        {/* Stubbed so that the first item is flush with the header. Space above takes care of it */}
        <XStack />
        {featuredVideos.map((video) => {
          return <VideoCard key={video.id} video={video} />
        })}
      </ScrollView>
    </YStack>
  )
}
